import { render } from "./EventsSidebar.vue?vue&type=template&id=6626e865"
import script from "./EventsSidebar.vue?vue&type=script&lang=js"
export * from "./EventsSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__